export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtVHS';
export const NAME = 'HodinovaSazba';

export const COLUMN_HOD_SZB = 'HOD_SZB';
export const COLUMN_GAR_SZB = 'GAR_SZB';
export const COLUMN_INTERNAL_HOURLY_RATE = 'INTERNAL_HOURLY_RATE';
